import React, { useMemo } from 'react';
import { shallow } from 'zustand/shallow';

import { useSharePanelStore } from 'src/common/store/share.store';
import { Breadcrumb, BreadcrumbContainer, BreadCrumbsComponent } from 'src/common/breadcrumbs/component';
import PersonalizatonLogo from '../../personalization/personalization-logo';

export const ShareSlideoverBreadcrumbs = () => {
  const { isConfigureMode, popLinkConfigType, linkConfigTree, aliasName, personalizationLogoUrl } = useSharePanelStore(
    (state) => ({
      isConfigureMode: state.isConfigureMode,
      popLinkConfigType: state.popLinkConfigType,
      linkConfigTree: state.linkConfigTree,
      aliasName: state.aliasName,
      activeAlias: state.activeAlias,
      personalizationLogoUrl:
        state.activeAlias?.personalization?.logo_url || state.activeAlias?.personalization_logo_url || null,
    }),
    shallow
  );

  const options = useMemo(() => {
    const additionalLinkTagIndex = linkConfigTree.indexOf('additional-link');
    let tree: Breadcrumb[] = linkConfigTree;

    if (additionalLinkTagIndex > -1) {
      const aliasSlug = aliasName && aliasName === '' ? 'New Link' : aliasName;
      const nameContainer: BreadcrumbContainer = {
        value: aliasSlug,
        item: (
          <div className='flex flex-row items-center space-x-1 max-w-[200px]'>
            <PersonalizatonLogo logoUrl={personalizationLogoUrl} />
            <span className='truncate'>{aliasSlug}</span>
          </div>
        ),
      };
      tree = [...linkConfigTree.slice(0, additionalLinkTagIndex), nameContainer];
    }

    tree = ['share', ...tree];

    const caseOptions = new Array(tree.length).fill({ case: 'capitalize' });
    if (additionalLinkTagIndex > -1) {
      caseOptions[additionalLinkTagIndex + 1] = { case: 'none' };
    }

    return { active: tree[tree.length - 1], tree, caseOptions };
  }, [aliasName, linkConfigTree, personalizationLogoUrl]);

  if (!isConfigureMode) return null;

  const activeValue = typeof options.active === 'string' ? options.active?.valueOf() : options.active.value;
  return (
    <div className='flex flex-row space-x-2'>
      <BreadCrumbsComponent
        value={activeValue}
        items={options.tree}
        itemOptions={options.caseOptions}
        onItemClick={popLinkConfigType}
      />
    </div>
  );
};
